import { useRef, useEffect } from 'react';
/**
 * This hook provides access to the value of any variable
 * from the previous render frame.
 * Even if multiple effects are flushed in a single render
 * loop, this hook still keeps the original value.
 */
export var usePreviousFrameValue = function (value) {
    var ref = useRef();
    useEffect(function () {
        var handle = requestAnimationFrame(function () {
            ref.current = value;
        });
        return function () { return cancelAnimationFrame(handle); };
    });
    return ref.current;
};
//# sourceMappingURL=index.js.map